export enum SortState {
    DEFAULT_STATE = 0,
    ASCENDING_STATE = 1,
    DESCDENDING_STATE = 2,
    RESET_STATE = 3
}
